module.exports = __webpack_public_path__ + "media/images/selectionBet__flagBg-ff5697fbd5bd2cfad9d758e9fbf2f111.jpg";